import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Divider
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import {
  createAPICode,
  updateAPICode
} from 'src/store/actions/KeyManagerActions';

function UpdateAPIKey({ open, handleClose, item }) {
  const [loading, setLoading] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentItem(item);
  }, [item]);

  const handleUpdateAPI = async values => {
    setLoading(true);
    const response = await dispatch(updateAPICode(values));
    if (response == 1) {
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="title">
        <Typography color="textPrimary" variant="h3">
          Update Key
        </Typography>
      </DialogTitle>
      <Divider />
      <Formik
        initialValues={{
          name: `${currentItem?.name}`,
          userid: `${currentItem?.userID}`,
          usersecret: '',
          id: `${currentItem?.id}`
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string()
            .trim()
            .max(255)
            .required('Name is required'),
          userid: Yup.string()
            .trim()
            .max(255)
            .required('User ID is required'),
          usersecret: Yup.string()
            .trim()
            .max(255)
        })}
        onSubmit={values => {
          handleUpdateAPI(values);
          // navigate('/app/dashboard', { replace: true });
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <TextField
                error={Boolean(touched.name && errors.name)}
                fullWidth
                helperText={touched.name && errors.name}
                label="Name"
                margin="normal"
                name="name"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.name}
                variant="outlined"
                size="small"
              />
              <TextField
                error={Boolean(touched.userid && errors.userid)}
                fullWidth
                helperText={touched.userid && errors.userid}
                label="User ID"
                margin="normal"
                name="userid"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.userid}
                variant="outlined"
                size="small"
                disabled
              />
              <TextField
                error={Boolean(touched.usersecret && errors.usersecret)}
                fullWidth
                helperText={touched.usersecret && errors.usersecret}
                label="User Secret Key"
                margin="normal"
                name="usersecret"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.usersecret}
                variant="outlined"
                size="small"
              />
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Close
              </Button>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                type="submit"
              >
                {loading && <CircularProgress size="1.5rem" />}
                &nbsp; Update
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}

export default UpdateAPIKey;
